import React from 'react'
import { Drawer } from "@mui/material";
import Styles from './InfoDrawer.module.scss';


const InfoDrawer = ({ drawerOpen, handleDrawer, titleText, displayData }) => {

	return (
		<div className={Styles.drawerContainer}>
			<Drawer BackdropProps={{ invisible: true }} anchor="right" open={drawerOpen} onClose={handleDrawer}>
				<div className={Styles.drawerContent}>
					<h2
						style={{
							fontSize: '30px',
							fontWeight: '600',
							textTransform: 'uppercase'
						}}
					>{titleText}</h2>
					<hr className={Styles.drawerDivider} />
					{Object.entries(displayData).map(([heading, items]) => (
						<div key={heading}
                        >
							<h3
								style={{
									fontWeight: '600'
								}}
							>{heading}</h3>
														{items.map((item, index) => (
								<div key={index}
									style={{
										display: 'flex',
										flexDirection: 'row',
										marginBottom: '9px'
									}}
								> {item.keyword && (
										<div
											style={{
												display: 'flex',
												justifyContent: 'left',
												padding: '4px',
												width: '100%',
												color: 'black',
												fontWeight: '600',
												fontFamily: 'monospace',
												fontSize: '14px'
											}}
										>
											{item.keyword}
										</div>
									)}
									<div
										style={{
											display: 'flex',
											justifyContent: 'left',
											width: '50vw',
											fontSize: '16px'
										}}
									>
										{item.description}
									</div>
								</div>
							))}
						</div>
					))}
				</div>
			</Drawer>
		</div>
	)
}

export default InfoDrawer
